<template>
  <router-view />
  
  <!-- 全局聊天通知 - 在所有页面都显示 -->
  <ChatNotification
    ref="chatNotification"
    @open-chat="openChatFromNotification"
  />
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import ChatNotification from '@/components/ChatNotification.vue'
import { supabase } from '@/utils/supabase'
import { chatManager } from '@/utils/chatManager'
import { getSecureStorage, SECURE_STORAGE_KEY, PLATFORM_TABLE_MAP } from '@/utils/security'

const router = useRouter()
const chatNotification = ref(null)

// 从通知打开聊天
function openChatFromNotification(orderId) {
  // 跳转到个人中心并打开聊天
  router.push('/mypage').then(() => {
    // 等待路由跳转完成后，通过事件或其他方式通知 MyPage 打开聊天
    // 由于 MyPage 监听 chatVisible 和 chatOrderId，我们需要触发它们
    // 这里可以使用 localStorage 或 eventBus
    localStorage.setItem('openChatOrderId', orderId)
    // 触发自定义事件
    window.dispatchEvent(new CustomEvent('openChatFromNotification', { detail: { orderId } }))
  })
}

// 获取已接订单并订阅聊天频道
async function subscribeToAcceptedOrders() {
  const savedUser = getSecureStorage(SECURE_STORAGE_KEY)
  if (!savedUser || !savedUser.username) {
    console.log('[App] 用户未登录，跳过订单订阅')
    return
  }
  
  console.log('[App] 用户已登录，开始订阅已接订单的聊天频道')
  
  try {
    const platform = savedUser.platform || 'mobile_delta'
    const tables = PLATFORM_TABLE_MAP[platform]
    
    const [ordersResult, xianyuResult] = await Promise.all([
      supabase
        .from(tables.orders)
        .select('id')
        .eq('handler_id', savedUser.username)
        .eq('status', 'processing'),
      supabase
        .from(tables.xianyu_order)
        .select('id')
        .eq('player', savedUser.username)
        .eq('status', 'processing')
    ])
    
    const ordersData = ordersResult.data || []
    const xianyuData = xianyuResult.data || []
    
    // 订阅普通订单
    ordersData.forEach(order => {
      console.log(`[App] 订阅订单 ${order.id} 的聊天频道`)
      chatManager.subscribe(order.id, null)
    })
    
    // 订阅闲鱼订单（需要添加前缀）
    xianyuData.forEach(order => {
      const orderId = 'xianyu_' + order.id
      console.log(`[App] 订阅闲鱼订单 ${orderId} 的聊天频道`)
      chatManager.subscribe(orderId, null)
    })
    
    console.log(`[App] 已订阅 ${ordersData.length + xianyuData.length} 个订单的聊天频道`)
  } catch (error) {
    console.error('[App] 订阅订单频道失败:', error)
  }
}

// 初始化聊天管理器
onMounted(() => {
  console.log('[App] 初始化全局聊天管理器')
  chatManager.init(supabase)
  
  // 设置全局通知处理器
  chatManager.setNotificationHandler((orderId, message) => {
    console.log('[App] 收到通知:', orderId, message)
    if (chatNotification.value) {
      chatNotification.value.addNotification(orderId, message)
    }
  })
  
  // 监听从其他页面跳转过来的打开聊天事件
  window.addEventListener('openChatFromNotification', (e) => {
    console.log('[App] 收到打开聊天事件:', e.detail)
    // 重新触发事件，让 MyPage 能够捕获
    setTimeout(() => {
      window.dispatchEvent(new CustomEvent('chatOrderSelected', { detail: e.detail }))
    }, 100)
  })
  
  // 如果用户已登录，自动订阅所有已接订单的聊天频道
  subscribeToAcceptedOrders()
})
</script>

<style>
@import './assets/css/global.css';
</style>
